import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type UpdateAiReservationColumnBody = Parameters<typeof apiClient.v3.columnControllerAiColumnUpdate>[0]

const updateAiReservationColumn = async (body: UpdateAiReservationColumnBody) => {
  const { data } = await apiClient.v3.columnControllerAiColumnUpdate(body)
  return checkApiResponse(data)
}

export const useReservationColumnAiUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateAiReservationColumnBody> = {}) => {
  return useMutation(() => ({
    mutationFn: updateAiReservationColumn,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
